import { mockBuilder } from '../../utils/builderHelper.es.js';
import { generateId } from '../../utils/generateId.es.js';
import { UserProfile } from './UserProfile.es.js';

/** @module Mocks */ /** typedoc */
function anUserProfile() {
    return mockBuilder(new UserProfile())
        .withId(generateId('user', 1))
        .withCity('city')
        .withCountry('country')
        .withEmail('email')
        .withFirstname('firstname')
        .withFullname('firstname lastname')
        .withHomePage('homepage')
        .withInitials('fl')
        .withLastname('lastname')
        .withLibraryId('library-id')
        .withPreferredCulture('preferred-culture')
        .withProfilePicture72Url('profile-picture-72-url')
        .withProfilePicture360Url('profile-picture-360-url')
        .withSendMarketingEmail(false)
        .withState('state');
}

export { anUserProfile };
